import { render } from "./ViewCard.vue?vue&type=template&id=15a5bd05"
import script from "./ViewCard.vue?vue&type=script&lang=js"
export * from "./ViewCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ViewCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15a5bd05"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15a5bd05', __exports__)) {
    api.reload('15a5bd05', __exports__)
  }
  
  module.hot.accept("./ViewCard.vue?vue&type=template&id=15a5bd05", () => {
    api.rerender('15a5bd05', render)
  })

}


export default __exports__